import { render, staticRenderFns } from "./CountryProfileMobile.vue?vue&type=template&id=11385c72&scoped=true&"
import script from "./CountryProfileMobile.vue?vue&type=script&lang=js&"
export * from "./CountryProfileMobile.vue?vue&type=script&lang=js&"
import style0 from "./CountryProfileMobile.vue?vue&type=style&index=0&id=11385c72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11385c72",
  null
  
)

export default component.exports